export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () => import(`@/views/NotFound.vue`)
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () => import(`@/views/Deny.vue`)
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () => import(`@/views/Error.vue`)
  },
  {
    path: "/login",
    meta: {
      public: true
    },
    name: "Login",
    component: () => import(`@/views/Login.vue`)
  },
  {
    path: "/",
    meta: {},
    name: "Root",
    redirect: {
      name: "Login"
    }
  },
  {
    path: "/dashboard",
    meta: { breadcrumb: true },
    name: "Dashboard",
    component: () => import(`@/views/Dashboard.vue`)
  },
  {
    path: "/policies",
    meta: { breadcrumb: true },
    name: "Policies",
    component: () => import(`@/views/policies/Policies.vue`)
  },
  {
    path: "/policies/create/:id",
    meta: { breadcrumb: true },
    name: "Policies Create",
    component: () => import(`@/views/policies/PoliciesCreate.vue`)
  },
  {
    path: "/policies/assigning",
    meta: { breadcrumb: true },
    name: "Assigning Policies",
    component: () => import(`@/views/policies/AssigningPolicies.vue`)
  },
  {
    path: "/companies",
    meta: { breadcrumb: true },
    name: "Company",
    component: () => import(`@/views/companies/Company.vue`)
  },
  {
    path: "/companies/create/:id",
    meta: { breadcrumb: true },
    name: "Companies Create",
    component: () => import(`@/views/companies/CompanyCreate.vue`)
  },
  {
    path: "/payments",
    meta: { breadcrumb: true },
    name: "Payments",
    component: () => import(`@/views/payments/Payments.vue`)
  },
  {
    path: "/modules",
    meta: { breadcrumb: true },
    name: "Module",
    component: () => import(`@/views/modules/Modules.vue`)
  },
  {
    path: "/payments/check/:id",
    meta: { breadcrumb: true },
    name: "Payment Check",
    component: () => import(`@/views/payments/PaymentsCheck.vue`)
  },
  {
    path: "/servers/create",
    meta: { breadcrumb: true },
    name: "SetupServer",
    component: () => import(`@/views/servers/SetupServer.vue`)
  },
  {
    meta: {},
    path: "/media",
    name: "Media",
    props: route => ({ type: route.query.type }),
    component: () => import(`@/views/Media.vue`)
  },
  {
    path: "/servers",
    meta: { breadcrumb: true },
    name: "Servers",
    component: () => import(`@/views/servers/Servers.vue`)
  },
  {
    path: "/releases",
    meta: { breadcrumb: true },
    name: "Releases",
    component: () => import(`@/views/releases/Releases.vue`)
  },
  {
    path: "/support",
    meta: { breadcrumb: true },
    name: "Support",
    component: () => import(`@/views/support/index.vue`)
  },
  {
    path: "/support/details",
    meta: { breadcrumb: true },
    name: "Support Details",
    component: () => import(`@/views/support/Details.vue`)
  },
  {
    path: "/release-notes",
    meta: { breadcrumb: true },
    name: "ReleaseNotes",
    component: () => import(`@/views/ReleaseNotes.vue`)
  }
];
